import type { WorkspaceContextIssue } from '@streamlain/copilot-realtime-contract';

export type WorkspaceContextMessageKey =
  `com.streamlain.copilot.surface.${WorkspaceContextIssue}`;
export function mapWorkspaceContextIssueToMessageKey(
  issue: WorkspaceContextIssue
): WorkspaceContextMessageKey {
  return `com.streamlain.copilot.surface.${issue}`;
}
